import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c31ed91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-title" }
const _hoisted_2 = { class: "status-desc" }
const _hoisted_3 = {
  key: 0,
  class: "qrcode-box"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qrcode-tip" }, "请使用微信扫码完成账户验证", -1))
const _hoisted_6 = { class: "type-selector" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type-selector-label" }, "主体类型", -1))
const _hoisted_8 = { class: "type-selector-options" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "type-card-name" }
const _hoisted_11 = { class: "type-card-desc" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 5px"} }, "~", -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 5px"} }, "~", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999","line-height":"1.4","margin-top":"10px"} }, [
  /*#__PURE__*/_createTextVNode(" 1、在支付完成页向买家展示，需与微信经营类目相关。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2、简称要求："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ① 不支持单纯以人名来命名，若为个体户经营，可用“个体户+经营者名称”或“经营者名称+业务”命名，如“个体户张三”或“张三餐饮店”；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ② 不支持无实际意义的文案，如“XX特约商户”、“800”、“XX客服电话XXX”； ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999","line-height":"1.4","margin-top":"10px"} }, [
  /*#__PURE__*/_createTextVNode(" 1、请填写真实有效的客服电话，将在交易记录中向买家展示，提供咨询服务"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2、请确保电话畅通，以便入驻后平台回拨确认 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_23 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.remoteInfo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["status-banner", 'status-' + _ctx.applyState.type])
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.applyState.title), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.applyState.desc), 1),
          (_ctx.remoteInfo.authUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.remoteInfo.authUrl,
                  alt: "微信账户验证二维码"
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-position": "right",
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectType, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: _normalizeClass(["type-card", { selected: _ctx.formData.subject_info.subject_type === item.value }]),
                onClick: ($event: any) => (_ctx.changeSubject(item.value))
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.desc), 1)
              ], 10, _hoisted_9))
            }), 128))
          ])
        ]),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "主体信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "营业执照",
              error: "请上传营业执照",
              data: _ctx.formData.subject_info.business_license_info.license_copy,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFiles('subject_info.business_license_info.license_copy')))
                }, [
                  (_ctx.showData[_ctx.formData.subject_info.business_license_info.license_copy])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.subject_info.business_license_info.license_copy],
                        style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                      }, null, 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, " 请上传营业执照 "))
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "注册号",
              data: _ctx.formData.subject_info.business_license_info.license_number,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.business_license_info.license_number,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.license_number) = $event)),
                  placeholder: " 请依据营业执照，填写统一社会信用代码 "
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: _ctx.merchantNameLabel,
              data: _ctx.formData.subject_info.business_license_info.merchant_name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.business_license_info.merchant_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.merchant_name) = $event)),
                  placeholder: '请输入' + _ctx.merchantNameLabel
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "data"]),
            _createVNode(_component_ui_form_item, {
              label: "注册地址",
              data: _ctx.formData.subject_info.business_license_info.license_address,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.business_license_info.license_address,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.license_address) = $event)),
                  placeholder: " 请依据营业执照/登记证书，填写注册地址 "
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "营业期限",
              error: "请选择营业期限",
              data: _ctx.formData.subject_info.business_license_info.period_begin && _ctx.formData.subject_info.business_license_info.period_end ? 'a' : '',
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  "value-format": "YYYY-MM-DD",
                  modelValue: _ctx.formData.subject_info.business_license_info.period_begin,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.period_begin) = $event)),
                  type: "date",
                  placeholder: "证件开始日期"
                }, null, 8, ["modelValue"]),
                _createTextVNode(),
                (_ctx.formData.subject_info.business_license_info.period_end != '长期')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_14,
                      _createVNode(_component_el_date_picker, {
                        "value-format": "YYYY-MM-DD",
                        modelValue: _ctx.formData.subject_info.business_license_info.period_end,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.period_end) = $event)),
                        type: "date",
                        placeholder: "证件结束日期"
                      }, null, 8, ["modelValue"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_checkbox, {
                  style: {"margin-left":"10px"},
                  onInput: _cache[6] || (_cache[6] = (v) => { _ctx.formData.subject_info.business_license_info.period_end = _ctx.formData.subject_info.business_license_info.period_end == '长期' ? '' : '长期' }),
                  "model-value": _ctx.formData.subject_info.business_license_info.period_end == '长期'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("长期")
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "经营者/法人姓名",
              data: _ctx.formData.subject_info.business_license_info.legal_person,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.business_license_info.legal_person,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.subject_info.business_license_info.legal_person) = $event)),
                  placeholder: "请输入法人姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "经营者/法人证件",
              data: _ctx.formData.subject_info.identity_info.id_doc_type,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.subject_info.identity_info.id_doc_type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_doc_type) = $event)),
                  placeholder: "请选择证件类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactIdDocType, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.name,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "请上传经营者/法人身份证",
              error: "请上传经营者/法人身份证",
              data: _ctx.formData.subject_info.identity_info.id_card_info.id_card_copy && _ctx.formData.subject_info.identity_info.id_card_info.id_card_national ? 'a' : '',
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadFiles('subject_info.identity_info.id_card_info.id_card_copy')))
                }, [
                  (_ctx.showData[_ctx.formData.subject_info.identity_info.id_card_info.id_card_copy])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.subject_info.identity_info.id_card_info.id_card_copy],
                        style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                      }, null, 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, " 请上传证件正面照 "))
                ]),
                _createElementVNode("div", {
                  style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd","margin-left":"20px"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uploadFiles('subject_info.identity_info.id_card_info.id_card_national')))
                }, [
                  (_ctx.showData[_ctx.formData.subject_info.identity_info.id_card_info.id_card_national])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.subject_info.identity_info.id_card_info.id_card_national],
                        style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                      }, null, 8, _hoisted_17))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, " 请上传证件反面照 "))
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件持有人姓名",
              data: _ctx.formData.subject_info.identity_info.id_card_info.id_card_name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.identity_info.id_card_info.id_card_name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_card_info.id_card_name) = $event)),
                  placeholder: "证件持有人姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件号码",
              data: _ctx.formData.subject_info.identity_info.id_card_info.id_card_number,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.identity_info.id_card_info.id_card_number,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_card_info.id_card_number) = $event)),
                  placeholder: "证件号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件持有人住址",
              data: _ctx.formData.subject_info.identity_info.id_card_info.id_card_address,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.subject_info.identity_info.id_card_info.id_card_address,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_card_info.id_card_address) = $event)),
                  placeholder: "请按照身份证住址填写"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "身份证有效期",
              error: "请选择证件有效期",
              data: _ctx.formData.subject_info.identity_info.id_card_info.card_period_begin && _ctx.formData.subject_info.identity_info.id_card_info.card_period_end ? 'a' : '',
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  "value-format": "YYYY-MM-DD",
                  modelValue: _ctx.formData.subject_info.identity_info.id_card_info.card_period_begin,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_card_info.card_period_begin) = $event)),
                  type: "date",
                  placeholder: "证件开始日期"
                }, null, 8, ["modelValue"]),
                _createTextVNode(),
                (_ctx.formData.subject_info.identity_info.id_card_info.card_period_end != '长期')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_19,
                      _createVNode(_component_el_date_picker, {
                        "value-format": "YYYY-MM-DD",
                        modelValue: _ctx.formData.subject_info.identity_info.id_card_info.card_period_end,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.subject_info.identity_info.id_card_info.card_period_end) = $event)),
                        type: "date",
                        placeholder: "证件结束日期"
                      }, null, 8, ["modelValue"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_checkbox, {
                  style: {"margin-left":"10px"},
                  onInput: _cache[16] || (_cache[16] = (v) => { _ctx.formData.subject_info.identity_info.id_card_info.card_period_end = _ctx.formData.subject_info.identity_info.id_card_info.card_period_end == '长期' ? '' : '长期' }),
                  "model-value": _ctx.formData.subject_info.identity_info.id_card_info.card_period_end == '长期'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("长期")
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "经营信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "商户简称",
              data: _ctx.formData.business_info.merchant_shortname,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.business_info.merchant_shortname,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.business_info.merchant_shortname) = $event)),
                  placeholder: "请输入商户简称"
                }, null, 8, ["modelValue"]),
                _hoisted_20
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "客服电话",
              data: _ctx.formData.business_info.service_phone,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.business_info.service_phone,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.business_info.service_phone) = $event)),
                    placeholder: "请输入客服电话"
                  }, null, 8, ["modelValue"]),
                  _hoisted_21
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "所属行业",
              data: _ctx.businessCategory,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_cascader, {
                    modelValue: _ctx.businessCategory,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.businessCategory) = $event)),
                    options: _ctx.businessList
                  }, null, 8, ["modelValue", "options"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.formData.settlement_info.settlement_id), 1)
                ])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "结算账户" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "账户类型",
              data: _ctx.formData.bank_account_info.bank_account_type,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.bank_account_info.bank_account_type,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.bank_account_info.bank_account_type) = $event)),
                  placeholder: "请选择银行卡类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankAccountType, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.name,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, { label: "开户名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.bankAccountName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ui_form_item, {
              label: "银行卡",
              data: _ctx.formData.bank_account_info.account_bank,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.bank_account_info.account_bank,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.bank_account_info.account_bank) = $event)),
                  placeholder: "请选择开户银行"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.name,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "开户支行",
              data: _ctx.cityCategory,
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_cascader, {
                    modelValue: _ctx.cityCategory,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.cityCategory) = $event)),
                    options: _ctx.bankCityList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "银行账号",
              data: _ctx.formData.bank_account_info.account_number,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.bank_account_info.account_number,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.bank_account_info.account_number) = $event)),
                  placeholder: "请输入银行账号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "超管信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "超管手机",
              data: _ctx.formData.contact_info.mobile_phone,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.contact_info.mobile_phone,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.contact_info.mobile_phone) = $event)),
                  placeholder: "请超管手机"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "超管邮箱",
              data: _ctx.formData.contact_info.contact_email,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.contact_info.contact_email,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.contact_info.contact_email) = $event)),
                  placeholder: "请输入邮箱，用来接收日常账号信息"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _ctx.submit,
        disabled: _ctx.readOnly,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.submitText), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])), [
        [_directive_loading, _ctx.submitLoading]
      ])
    ])
  ]))
}